export var Role;
(function (Role) {
    Role["Villager"] = "villager";
    Role["Ghost"] = "ghost";
    Role["Fool"] = "fool";
})(Role || (Role = {}));
export var WinCondition;
(function (WinCondition) {
    WinCondition["None"] = "none";
    WinCondition["VillageElimination"] = "village_elimination";
    WinCondition["GhostsByParity"] = "ghosts_by_parity";
    WinCondition["GhostsByGuess"] = "ghosts_by_guess";
    WinCondition["Stalemate"] = "stalemate";
})(WinCondition || (WinCondition = {}));
//# sourceMappingURL=roles.js.map